import React from "react";
import { 
  Alert, 
  Box, 
  Typography, 
  Link, 
  Button, 
  Chip,
  ToggleButtonGroup,
  ToggleButton,
  Divider
} from "@mui/material";
import { 
  Warning, 
  CloudOff, 
  Print, 
  CheckCircle, 
  Settings,
  Code,
  PictureAsPdf
} from "@mui/icons-material";

const PrinterStatusAlert = ({ 
  onInstallBridge, 
  bridgeConnected, 
  onPrint, 
  onConfigurePrinter, 
  selectedPrinter,
  labelLoading,
  labelError,
  labelFormat,
  onFormatChange,
  disabled = false
}) => {
  if (bridgeConnected) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          bgcolor: "rgba(76, 175, 80, 0.1)",
          borderRadius: 2,
          p: 2,
          border: "1px solid rgba(76, 175, 80, 0.3)"
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Chip
            icon={<CheckCircle />}
            label="Bridge Online"
            size="small"
            color="success"
            variant="filled"
            sx={{ fontWeight: 600, fontSize: "0.75rem" }}
          />
          
          <Button
            variant="outlined"
            color="success"
            size="small"
            startIcon={<Settings />}
            onClick={onConfigurePrinter}
            sx={{
              fontWeight: 600,
              textTransform: "none",
              fontSize: "0.75rem",
              minWidth: "auto",
              px: 1.5
            }}
          >
            Configurar
          </Button>
        </Box>
        
        <Divider sx={{ borderColor: "rgba(76, 175, 80, 0.3)" }} />
        
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
          <ToggleButtonGroup
            value={labelFormat}
            exclusive
            onChange={(_, format) => format && onFormatChange(format)}
            size="small"
            sx={{
              "& .MuiToggleButton-root": {
                fontSize: "0.75rem",
                px: 2,
                py: 0.5,
                fontWeight: 600,
                textTransform: "none",
                border: "1px solid rgba(76, 175, 80, 0.5)",
                "&.Mui-selected": {
                  bgcolor: "success.main",
                  color: "white",
                  "&:hover": {
                    bgcolor: "success.dark"
                  }
                }
              }
            }}
          >
            <ToggleButton value="zpl">
              <Code sx={{ fontSize: "1rem", mr: 0.5 }} />
              ZPL
            </ToggleButton>
            <ToggleButton value="pdf">
              <PictureAsPdf sx={{ fontSize: "1rem", mr: 0.5 }} />
              PDF
            </ToggleButton>
          </ToggleButtonGroup>
          
          <Button
            variant="contained"
            color="warning"
            size="medium"
            startIcon={<Print />}
            onClick={onPrint}
            disabled={!selectedPrinter || labelLoading || disabled}
            sx={{
              fontWeight: 700,
              textTransform: "none",
              fontSize: "0.9rem",
              px: 3,
              py: 1,
              boxShadow: "0 4px 12px rgba(76, 175, 80, 0.3)",
              "&:hover": {
                boxShadow: "0 6px 16px rgba(76, 175, 80, 0.4)"
              },
              "&:disabled": {
                bgcolor: "grey.300"
              }
            }}
          >
            {labelLoading ? "Imprimindo..." : "Imprimir Etiqueta"}
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <Alert
      severity="error"
      icon={<CloudOff />}
      sx={{ 
        mb: 0,
        borderRadius: 2,
        border: "1px solid rgba(244, 67, 54, 0.3)",
        bgcolor: "rgba(244, 67, 54, 0.05)",
        "& .MuiAlert-message": {
          width: "100%"
        }
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 1,
          width: "100%",
        }}
      >
        <Box>
          <Typography 
            variant="body2" 
            sx={{ 
              fontSize: { xs: "0.8rem", md: "0.875rem" },
              fontWeight: 600,
              color: "error.dark"
            }}
          >
            🔌 Bridge Desconectado
          </Typography>
          <Typography 
            variant="caption" 
            sx={{ 
              fontSize: { xs: "0.7rem", md: "0.75rem" },
              color: "error.main",
              display: "block"
            }}
          >
            Impressão ZPL indisponível
          </Typography>
        </Box>
        
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={onInstallBridge}
          sx={{
            fontWeight: 700,
            textTransform: "none",
            fontSize: { xs: "0.75rem", md: "0.8rem" },
            whiteSpace: "nowrap",
            boxShadow: "0 4px 12px rgba(244, 67, 54, 0.3)",
            "&:hover": {
              boxShadow: "0 6px 16px rgba(244, 67, 54, 0.4)"
            }
          }}
        >
          Instalar Bridge
        </Button>
      </Box>
    </Alert>
  );
};

export default PrinterStatusAlert;
